import { configureStore } from '@reduxjs/toolkit';

import presaleReducer from './presale';
import exchangeReducer from './exchange';
import investorRewardsReducer from './investor-info';
import investorRewardsReducer2 from './investor-info-v2';
import accountReducer from './account';
import fundInforeducer from './fund-info';
import bountyReducer from './bounty';
import stakingReducer from './staking';
import idoReducer from './idos';
import flashStakingReducer from './flash-staking';
import autoCompundRelockReducer from './autocompound-relock';
import vaultStakingReducer from './vault-staking';

const createStore = () => configureStore({
  reducer: {
    presale: presaleReducer,
    exchange: exchangeReducer,
    investorRewards: investorRewardsReducer,
    investorRewards2: investorRewardsReducer2,
    account: accountReducer,
    fundInfo: fundInforeducer,
    bountyInfo: bountyReducer,
    stakingInfo: stakingReducer,
    idos: idoReducer,
    flashStaking: flashStakingReducer,
    vaultStaking: vaultStakingReducer,
    autoCompoundRelock: autoCompundRelockReducer,
  },
  devTools: process.env.NODE_ENV !== 'production'
});

export default createStore;